export default (params) => ({
  trigger: {
    name: 'product_type_section.show_accessory_products',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
    },
    event: {
      name: 'show_accessory_items',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
